/**
 * GA4 配置 —— 按 host 匹配媒体资源 + debug 开关
 *
 * 跟 src/utils/ga4.js、src/utils/ga4-init.js 配套使用
 * 加新站点:加一个 entry,按 host 匹配
 * apiSecret 跟 measurementId 配套 —— 换媒体资源必须一起换
 */

// 三种 host 全部走同一个 GA4 媒体资源(G-T7BFZZWSBM)
const GA4_CONFIGS = {
  localhost: {
    measurementId: 'G-T7BFZZWSBM',
    apiSecret: '9MM9nXXlQKafvssUaCeNDw',
    debug: true
  },
  'aitest.hairfunny.com': {
    measurementId: 'G-T7BFZZWSBM',
    apiSecret: '9MM9nXXlQKafvssUaCeNDw',
    debug: false
  },
  'ai.hairfunny.com': {
    measurementId: 'G-T7BFZZWSBM',
    apiSecret: '9MM9nXXlQKafvssUaCeNDw',
    debug: false
  }
}

// 兜底配置(host 没匹配到时用)
const DEFAULT_GA4_CONFIG = {
  measurementId: 'G-T7BFZZWSBM',
  apiSecret: '9MM9nXXlQKafvssUaCeNDw',
  debug: false
}

export function getGA4Config() {
  if (typeof window === 'undefined') return DEFAULT_GA4_CONFIG

  const hostname = window.location.hostname

  // 精确匹配
  if (GA4_CONFIGS[hostname]) return GA4_CONFIGS[hostname]

  // 顶级域名后缀匹配:subdomain 自动继承主域配置
  for (const key of Object.keys(GA4_CONFIGS)) {
    if (hostname === key || hostname.endsWith('.' + key)) {
      return GA4_CONFIGS[key]
    }
  }

  return DEFAULT_GA4_CONFIG
}
